import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'

export const orgReposListAppBuilder = DataRouterApplicationBuilder.create('org-repos-list')
